module.exports = __webpack_public_path__ + "img/image--header.7b3d9753.svg";